module.exports = __webpack_public_path__ + "static/media/options.b60cf6d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/options.svg
// module id = 950
// module chunks = 5